module.exports = "import React from 'react';\nimport { UncontrolledAlert } from 'reactstrap';\n\nfunction AlertExample() {\n  return (\n    <UncontrolledAlert color=\"info\">\n      I am an alert and I can be dismissed!\n    </UncontrolledAlert>\n  );\n}\n\nexport default AlertExample;\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./docs/lib/examples/AlertUncontrolledDismiss.js
// module id = 327
// module chunks = 0